import React, { useEffect, useLayoutEffect, useState } from "react";

import "./messageListCard.scss";
import { IonAlert, IonCol, IonIcon, IonModal, IonPopover } from "@ionic/react";
import { Link } from "react-router-dom";
import { utilService } from "../../../services";
import _ from "lodash";
import FileShareMediaList from "../../../pages/FileShare/components/FileShareMediaList/FileShareMediaList";
import MediaUpload from "../../../pages/FileShare/components/MediaUpload/MediaUpload";
import SelectUserComponent from "../../../pages/FileShare/components/SelectUserComponent/SelectUserComponent";
import { dataTransferService } from "../../../services/dataTransferService";
import {
  arrowUndoOutline,
  attachOutline,
  chevronBackOutline,
  chevronDownCircle,
  chevronUpCircle,
  close,
  ellipsisVertical,
  eyeOutline,
  trashOutline,
  peopleOutline,
  imageOutline,
  videocamOutline,
  volumeHighOutline,
} from "ionicons/icons";
import MessageHistory from "./MessageHistoryComponent/MessageHistory";
import { setMessageListService } from "./messageListCard.service";
import dayjs from "dayjs";
import Call from "../Call/call";
import { useToast } from "@agney/ir-toast";

interface MessageListCardProps {
  listData: any;
  index: any;
  componentName: any;
  isUserChatWebComponent?: any;
  isFromHomeSection?: any;
  isShowPopOver?: boolean;
  updateForwardMessages?: any;
  fromHomePage?: any;
  updateList?: any;
  getSelectedMessageCard: (selectedMessageCard: any) => void;
  isShowSelectUserModal?: boolean;
  setIsShowSelectUserModal?: any;
  handleClick: any;
  selectedUsrMsg?: any;
}
const MessageListCard: React.FC<MessageListCardProps> = (props) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedGuid, setSelectedGuid]: any = useState([]);
  const [selectedUserName, setSelectedName]: any = useState([]);
  const [isShowMediaListModal, setIsShowMediaListModal] = useState(false);
  const [isShowUploadMediaModal, setIsShowUploadMediaModal] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert]: any = useState(false);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });
  const [dataFromParentComponent, setDataFromParentComponent]: any = useState(
    []
  );
  const [showMoreButton, setShowMoreButton] = useState(false);
  const [isMoreButtonClicked, setIsMoreButtonClicked] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [columnSize, setColumnSize] = useState("4");
  const [forwardMessageDetails, setForwardMessageDetails]: any = useState();
  const [isForwardMessage, setForwardMessage]: any = useState(false);
  const [fromUserGuid, setFromUserGuid]: any = useState();

  const Toast = useToast();

  useEffect(() => {
    checkIfLargeScreen();
  }, []);

  useEffect(() => {
    if (props.listData.from_user) {
      setFromUserGuid(props.listData.from_user.guid);
    }
  }, []);

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  useEffect(() => {
    if (props.isFromHomeSection) {
      setColumnSize("12");
    }
  }, [props.isFromHomeSection]);

  useEffect(() => {
    if (props.isUserChatWebComponent) {
      setColumnSize("12");
    }
  }, [props.isUserChatWebComponent]);

  useEffect(() => {
    if (!_.isEmpty(props.listData.text)) {
      let length;
      utilService.getScreenSize() === "small" ? (length = 25) : (length = 46);
      props.listData.text.length > length
        ? setShowMoreButton(true)
        : setShowMoreButton(false);
    }
  }, [props.listData]);

  useLayoutEffect(() => {
    let sub = dataTransferService.getReplyMediaAction.subscribe((data: any) => {
      if (!_.isEmpty(data)) {
        setIsShowMediaListModal(false);
        props?.setIsShowSelectUserModal(false);
        setIsShowUploadMediaModal(true);
        setDataFromParentComponent(data);
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getForwardMediaAction.subscribe(
      (data: any) => {
        if (!_.isEmpty(data)) {
          setIsShowMediaListModal(false);
          setIsShowUploadMediaModal(false);
          props?.setIsShowSelectUserModal(true);
          setDataFromParentComponent(data);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const onViewMediaClick = (userData: any) => {
    setShowPopover({ showPopover: false, event: undefined });
    setIsShowModal(true);
    setSelectedGuid(userData.from_user.guid);
    setSelectedName(userData.from_user.first_name);
    setIsShowMediaListModal(true);
  };

  const handleMoreButtonClick = () => {
    const mediaListCard: any = document.getElementById(
      `media-list-card-item-wrapper${props.index}`
    );

    const messageContainer: any = document.getElementById(
      `message-container${props.index}`
    );
    if (mediaListCard) {
      setDynamicCardHeight(mediaListCard, messageContainer);
    }
  };

  const getFormattedDateAndTime = (date: any) => {
    const today = dayjs(date).format("MM-DD-YYYY hh:mm A");
    return today;
  };

  const setDynamicCardHeight = (mediaListCard: any, messageContainer: any) => {
    if (props.listData?.text.length === 250) {
      mediaListCard?.style.setProperty("height", `33vh`);
      messageContainer?.style.setProperty("height", `22vh`);
    } else if (
      props.listData?.text.length < 250 &&
      props.listData?.text.length >= 200
    ) {
      mediaListCard?.style.setProperty("height", `29vh`);
      messageContainer?.style.setProperty("height", `19vh`);
    } else if (
      props.listData?.text.length < 200 &&
      props.listData?.text.length >= 150
    ) {
      mediaListCard?.style.setProperty("height", `29vh`);
      messageContainer?.style.setProperty("height", `17vh`);
    } else if (
      props.listData?.text.length < 150 &&
      props.listData?.text.length >= 100
    ) {
      mediaListCard?.style.setProperty("height", `24vh`);
      messageContainer?.style.setProperty("height", `14vh`);
    } else if (
      props.listData?.text.length < 100 &&
      props.listData?.text.length >= 75
    ) {
      mediaListCard?.style.setProperty("height", `19vh`);
      messageContainer?.style.setProperty("height", `8vh`);
    } else {
      mediaListCard?.style.setProperty("height", `17vh`);
      messageContainer?.style.setProperty("height", `6vh`);
    }
  };

  const handleLessButtonClick = () => {
    const mediaListCard: any = document.getElementById(
      `media-list-card-item-wrapper${props.index}`
    );
    const messageContainer: any = document.getElementById(
      `message-container${props.index}`
    );
    if (mediaListCard) {
      mediaListCard?.style.setProperty("height", "95px");
      messageContainer?.style.setProperty("height", "25px");
    }
  };

  const handleDetailsHandleClick = (e: any) => {
    e.stopPropagation();
    if (showMoreButton && !isMoreButtonClicked) {
      handleMoreButtonClick();
      setIsMoreButtonClicked(true);
    }
  };

  const handleDeleteMessage = async () => {
    const params = getDeleteMessagesApiParams();
    const apiResponse: any = await setMessageListService.removeMessageListItem(
      params
    );
    if (apiResponse.isSuccess) {
      props.updateList();
      Toast.success("Message deleted successfully");
    } else {
      Toast.error(apiResponse?.message);
    }
  };

  const getDeleteMessagesApiParams = () => {
    let type = "";
    if (props.listData.is_media) {
      type = "media";
    } else {
      type = "message";
    }
    const params = {
      reg_code: utilService.getNetwork(),
      id: props.listData.id,
      type: type,
    };
    return params;
  };

  const updateMessageStatus = (messageID: any) => {
    const params = {
      reg_code: utilService.getNetwork(),
      message_id: messageID,
      is_seen: true,
    };

    const apiResponse: any =
      setMessageListService.updateMessageReadStatus(params);
  };

  const viewMessages = (messageId: any) => {
    if (utilService.getScreenSize() === "small") {
      setShowHistoryModal(true);
      setShowPopover({ showPopover: false, event: undefined });
      updateMessageStatus(messageId);
    } else if (window.innerWidth == 1280) {
      setShowHistoryModal(true);
      setShowPopover({ showPopover: false, event: undefined });
      updateMessageStatus(messageId);
    }
  };

  const updateForwardMessageData = (forwardMsgDetails: any) => {
    setForwardMessageDetails(forwardMsgDetails);
    setForwardMessage(true);
  };

  const handleUserMessageOnCancel = () => {
    setForwardMessage(false);
  };

  const inActiveUserCheck = () => {
    Toast.error("Inactive User");
  };

  const handleMessageClick = () => {
    console.log("test msgs handleMessageClick");
    props.handleClick();
  };

  return (
    <IonCol
      className="base-column-messagecard"
      size="12"
      size-lg={columnSize}
      id={`base-column-messagecard${props.listData.id}`}
    >
      {/* <div
        className={`list-card ${
          props.listData.isSelected ? "active-message-card" : ""
        }
        ${
          !props.listData.is_seen && !props.fromHomePage
            ? "unread-message-card"
            : ""
        }`}
        id={`media-list-card-item-wrapper${props.index}`}
        onClick={() => {
          if (!props.fromHomePage) {
            props.getSelectedMessageCard(props.listData);
            updateMessageStatus(props.listData.id);
          }
        }}
      >
        <div className="content-wrapper">
          <div
            className="file-share-icon-div"
            onClick={() => {
              if (!props.fromHomePage) {
                props.getSelectedMessageCard(props.listData);
                viewMessages(props.listData.id);
              }
            }}
          >
            {props.listData.media_attachment && (
              // <div className="icon-media-attachment" title="media message"></div>
              <IonIcon
                className="icon-media-attachments"
                icon={attachOutline}
              ></IonIcon>
            )}
            {!props.listData.media_attachment && (
              <div className="icon-speech-bubble" title="message"></div>
            )}
          </div>
          <div className="message-details-container">
            <div className="from-details-name">
              From:{" "}
              <span className="from-name">
                {props.listData.from_user.first_name}{" "}
                {props.listData.from_user.last_name}
              </span>{" "}
            </div>
            <div
              id={`message-container${props.index}`}
              className={`message-details-wrapper ${
                isMoreButtonClicked
                  ? `message-details-wrapper-more${props.index}`
                  : ""
              } ${showMoreButton && "cursor-show"}`}
              onClick={(e: any) => {
                !props.isUserChatWebComponent && handleDetailsHandleClick(e);
              }}
            >
              <div
                className={` message-details adjust-message-font ${
                  isMoreButtonClicked ? "message-details-more" : ""
                }`}
              >
                {props.listData.text}
                {utilService.getScreenSize() === "small" &&
                  props.listData.is_media && (
                    <span
                      className="icon-view_media sm-media-view-icon"
                      onClick={() => onViewMediaClick(props.listData)}
                    ></span>
                  )}
                {props.isFromHomeSection && props.listData.is_media && (
                  <span
                    className="icon-view_media sm-media-view-icon"
                    onClick={() => onViewMediaClick(props.listData)}
                  ></span>
                )}
              </div>
            </div>
            <div className="dateCreated-div">
              <div className="dateCreated">
                {getFormattedDateAndTime(props.listData.created_on)}
              </div>
              {!props.isUserChatWebComponent && (
                <div className="more-button-div" title="show more">
                  <div
                    className={
                      showMoreButton && !isMoreButtonClicked
                        ? "more-button"
                        : "hide-button"
                    }
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleMoreButtonClick();
                      setIsMoreButtonClicked(true);
                    }}
                  >
                    <IonIcon slot="start" icon={chevronDownCircle} />
                  </div>
                </div>
              )}
              {!props.isUserChatWebComponent && (
                <div className="more-button-div" title="show less">
                  <div
                    className={
                      isMoreButtonClicked ? "more-button" : "hide-button"
                    }
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleLessButtonClick();
                      setIsMoreButtonClicked(false);
                    }}
                  >
                    <IonIcon slot="start" icon={chevronUpCircle} />
                  </div>
                </div>
              )}
            </div>
          </div>
          {!props.isUserChatWebComponent && (
            <div
              className="message-options-div"
              title="Message Options"
              onClick={(e: any) => {
                e.persist();
                e.stopPropagation();
                !props.isShowPopOver &&
                  setShowPopover({
                    showPopover: true,
                    event: e,
                  });
              }}
            >
              <IonIcon icon={ellipsisVertical}></IonIcon>
            </div>
          )}
          <IonAlert
            isOpen={showDeleteAlert}
            onDidDismiss={() => setShowDeleteAlert(false)}
            cssClass="message-list-delete-alert"
            header="Confirmation Message"
            message="Are you sure you want to delete this message?"
            buttons={[
              {
                text: "NO",
                role: "cancel",
                cssClass: "secondary",
              },
              {
                text: "YES",
                handler: () => {
                  handleDeleteMessage();
                },
              },
            ]}
          />
          <IonPopover
            className="message-list-options"
            event={popoverState.event}
            isOpen={popoverState.showPopover}
            onDidDismiss={() => {
              setShowPopover({ showPopover: false, event: undefined });
            }}
          >
            <div className="media-list-options-wrapper">
              {props.listData.is_group_sms && !props.listData.is_media && (
                <div>
                  <Link
                    to={{
                      pathname: `/client/${props.componentName}`,
                      state: {
                        msgData: props.listData,
                        replyAll: false,
                      },
                    }}
                  >
                    <div className="media-list-icon">
                      <IonIcon
                        icon={arrowUndoOutline}
                        className="icon-div"
                      ></IonIcon>
                      <div className="media-list-label">Reply</div>
                    </div>
                  </Link>
                  <Link
                    to={{
                      pathname: `/client/${props.componentName}`,
                      state: {
                        msgData: props.listData,
                        replyAll: true,
                        isFromHome: props.isFromHomeSection,
                      },
                    }}
                  >
                    <div className="media-list-icon">
                      <div className="icon-Reply-All"></div>
                      <div className="media-list-label">Reply All</div>
                    </div>{" "}
                  </Link>
                </div>
              )}

              {!props.listData.is_group_sms && !props.listData.is_media && (
                <>
                  {props.listData.from_user.is_active ? (
                    <Link
                      to={{
                        pathname: `/client/${props.componentName}`,
                        state: {
                          msgData: props.listData,
                          replyAll: false,
                          isFromHome: true,
                        },
                      }}
                    >
                      {" "}
                      <div className="media-list-icon">
                        <IonIcon
                          icon={arrowUndoOutline}
                          className="icon-div"
                        ></IonIcon>
                        <div className="media-list-label">Reply</div>
                      </div>
                    </Link>
                  ) : (
                    <div
                      className="media-list-icon"
                      onClick={inActiveUserCheck}
                    >
                      <IonIcon
                        icon={arrowUndoOutline}
                        className="icon-div"
                      ></IonIcon>
                      <div className="media-list-label">Reply</div>
                    </div>
                  )}
                </>
              )}

              {props.listData.is_media && (
                <div
                  className="media-list-icon"
                  title="View"
                  onClick={() => onViewMediaClick(props.listData)}
                >
                  <IonIcon icon={eyeOutline} className="icon-div"></IonIcon>
                  <div className="media-list-label">View</div>
                </div>
              )}
              <div className="media-list-icon">
                <Call
                  selectedDoctorGuid={fromUserGuid}
                  isFromMessages={true}
                ></Call>
              </div>
              <div
                className="media-list-icon"
                onClick={() => {
                  setShowPopover({ showPopover: false, event: undefined });
                  setShowDeleteAlert(true);
                }}
              >
                <IonIcon icon={trashOutline} className="icon-div"></IonIcon>
                <div className="media-list-label">Delete</div>
              </div>
            </div>
          </IonPopover>
        </div>
      </div> */}
      <div
        onClick={handleMessageClick}
        className={`message-list-item ${
          props?.listData?.unread_message_count !== 0 && "active-message-card-new"
        }  ${
          props?.listData?.sms_thread_id ===
            props?.selectedUsrMsg?.sms_thread_id && "selected-message-card"
        }`}
      >
        <div className="profile-picture-container">
          {props?.listData?.is_group_sms ? (
            <div className="group-sms-icon-container">
              <IonIcon icon={peopleOutline} className="icon-div" size="large" />
            </div>
          ) : (
            <img
              className="profile-picture"
              // A null avatar used to build ".../null" and fetch a 404 for every
              // thread without a picture; onError then swapped in the default.
              src={
                props?.listData?.thread_avatar
                  ? `${utilService.getBaseUrl()}/${props.listData.thread_avatar}`
                  : "assets/images/defaultProfilePic.png"
              }
              onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                const target = e.target as HTMLImageElement;
                target.src = "assets/images/defaultProfilePic.png";
              }}
              alt=""
            />
          )}
          <span className="online-dot"></span>
        </div>
        <div className="profile-details-container">
          <div className="profile-text-container">
            <p className="profile-name">
              {props?.listData?.is_group_sms
                ? props?.listData?.thread_users
                    ?.map((user: any) => user?.first_name)
                    ?.join(", ")
                : props?.listData?.thread_users?.[0]?.last_name
                  ? `${props?.listData?.thread_users[0]?.first_name} ${props?.listData?.thread_users[0]?.last_name}`
                  : props?.listData?.thread_users?.[0]?.first_name || "Doctor"}
            </p>
            {/* {props?.listData?.message_settings?.is_n2n_message&&<div className="n2n-icon">
                <N2NIcon/>
              </div>} */}
          </div>
          {!props?.listData?.recent_message_has_media&&<p className="recent-message">{props?.listData?.recent_message}</p>}
          {props?.listData?.recent_message_has_media && (
            <>
              {props?.listData?.recent_message_type === "Image" && (
                <div className="media-message-container">
                  <IonIcon icon={imageOutline} />
                  <p>Image</p>
                </div>
              )}
              {props?.listData?.recent_message_type === "Video" && (
                <div className="media-message-container">
                  <IonIcon icon={videocamOutline} />
                  <p>Video</p>
                </div>
              )}
              {props?.listData?.recent_message_type === "Audio" && (
                <div className="media-message-container">
                  <IonIcon icon={volumeHighOutline} />
                  <p>Audio</p>
                </div>
              )}
            </>
          )}
        </div>
        <div className="date-container">
          <p className="date">
            {props?.listData?.created_on
              ? `${Math.max(1, Math.abs(dayjs().diff(dayjs(props?.listData?.created_on), "minute")))} min ago`
              : "11 min ago"}
          </p>
        </div>
            
        {props?.listData?.message_settings?.is_n2n_message&&
        <div className="n2n-icons-conatiner">
          <div className="n2n-icon">
            <N2NIcon/>
          </div>
          <div className="network-text">
            <div className="site-icon">
                <SiteIcon/>
              </div>
            <p>{props?.listData?.message_settings?.thread_users_network?.toString()}</p>
          </div>
        </div>
        }
        {props?.listData?.unread_message_count !== 0 && (
          <div className="recent-count-container">
            <p className="recent-count">
              {props?.listData?.unread_message_count}
            </p>
          </div>
        )}
        
      </div>
      <MessageHistory
        messageInfoData={props.listData}
        isShowMessageModal={showHistoryModal}
        onCancel={() => {
          setShowHistoryModal(false);
          props.updateList();
        }}
        updateForwardMessage={updateForwardMessageData}
      ></MessageHistory>

      <IonModal
        isOpen={isForwardMessage}
        backdropDismiss={false}
        className="forward-message-modal"
      >
        <div className="user-chat-message-details-wrapper">
          <div className="file-share-select-user-header">
            <div
              className="back-icon-fwd"
              onClick={() => {
                handleUserMessageOnCancel();
              }}
            >
              <IonIcon icon={chevronBackOutline} />
            </div>
            <div className="Forward-header-label">Select</div>
          </div>
          <SelectUserComponent
            onCancel={() => {
              // setIsShowSelectUserModal(false);
              // setIsShowMediaListModal(true);
              handleUserMessageOnCancel();
            }}
            dataFromParentComponent={dataFromParentComponent}
            getSelectedCard={() => {}}
            isMessageComponent={true}
            isForwardMessage={true}
            forwardMessageDetails={forwardMessageDetails}
          ></SelectUserComponent>
        </div>
      </IonModal>

      {!_.isEmpty(selectedGuid) && (
        <IonModal
          isOpen={isShowModal}
          backdropDismiss={false}
          className="media-list-modal media-modal"
        >
          <div className="media-list-modal-container">
            <div
              className={`close-modal-icon ${
                isSmallScreen ? "close-modal-icon-small-screen" : ""
              }`}
              onClick={() => {
                setIsShowModal(false);
                setIsShowMediaListModal(false);
                setIsShowUploadMediaModal(false);
                props?.setIsShowSelectUserModal(false);
              }}
            >
              <IonIcon icon={close} />
            </div>
            {isShowMediaListModal && (
              <div className="attach-media-content">
                <FileShareMediaList
                  selectedUserGuid={selectedGuid}
                  selectedUserName={selectedUserName}
                  smsThreadId={props.listData.sms_thread_id}
                  onUploadButtonClicked={() => {
                    setIsShowMediaListModal(false);
                    setIsShowUploadMediaModal(false);
                    setIsShowUploadMediaModal(true);
                  }}
                  isSmallScreen={true}
                ></FileShareMediaList>
              </div>
            )}
            {isShowUploadMediaModal && (
              <div className="attach-media-content">
                <MediaUpload
                  isGroupMediaShare={true}
                  doctorListDataFromParent={selectedGuid}
                  isNotificationCard={true}
                  dataFromParentComponent={dataFromParentComponent}
                  onOk={() => {}}
                  onCancel={() => {
                    setIsShowMediaListModal(true);
                    setIsShowUploadMediaModal(false);
                    setIsShowUploadMediaModal(false);
                  }}
                  isSmallScreen={true}
                ></MediaUpload>
              </div>
            )}
            {props?.isShowSelectUserModal && (
              <SelectUserComponent
                isModalPopUpScreen={true}
                onCancel={() => {
                  props?.setIsShowSelectUserModal(false);
                  setIsShowMediaListModal(true);
                }}
                dataFromParentComponent={dataFromParentComponent}
                getSelectedCard={() => {}}
                forwardMessageDetails={forwardMessageDetails}
              ></SelectUserComponent>
            )}
          </div>
        </IonModal>
      )}
    </IonCol>
  );
};

export default MessageListCard;

const N2NIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" fill="none">
<path d="M26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14Z" stroke="#4554fa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 19V9H11.0872L17.5203 16.2H16.5078V9H19V19H16.9283L10.4798 11.8H11.4922V19H9Z" fill="#4554fa"/>
</svg>
  );
};

export const SiteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none">
      <path
        d="M53.3346 469.333H458.668C461.497 469.333 464.21 468.209 466.21 466.209C468.211 464.208 469.335 461.495 469.335 458.666V202.666C469.335 199.837 468.211 197.124 466.21 195.124C464.21 193.123 461.497 191.999 458.668 191.999H405.335V95.9994C405.335 93.1704 404.211 90.4573 402.21 88.4569C400.21 86.4565 397.497 85.3327 394.668 85.3327H341.335V74.666C341.335 66.1791 337.963 58.0398 331.962 52.0386C325.961 46.0374 317.822 42.666 309.335 42.666H202.668C194.181 42.666 186.042 46.0374 180.041 52.0386C174.039 58.0398 170.668 66.1791 170.668 74.666V85.3327H117.335C114.506 85.3327 111.793 86.4565 109.792 88.4569C107.792 90.4573 106.668 93.1704 106.668 95.9994V191.999H53.3346C50.5057 191.999 47.7926 193.123 45.7922 195.124C43.7918 197.124 42.668 199.837 42.668 202.666V458.666C42.668 461.495 43.7918 464.208 45.7922 466.209C47.7926 468.209 50.5057 469.333 53.3346 469.333ZM405.335 213.333H448.001V447.999H405.335V213.333ZM288.001 447.999H224.001V373.333H288.001V447.999ZM192.001 74.666C192.001 71.837 193.125 69.1239 195.125 67.1235C197.126 65.1232 199.839 63.9993 202.668 63.9993H309.335C312.164 63.9993 314.877 65.1232 316.877 67.1235C318.878 69.1239 320.001 71.837 320.001 74.666V181.333C320.001 184.162 318.878 186.875 316.877 188.875C314.877 190.876 312.164 191.999 309.335 191.999H202.668C199.839 191.999 197.126 190.876 195.125 188.875C193.125 186.875 192.001 184.162 192.001 181.333V74.666ZM128.001 106.666H170.668V181.333C170.668 189.82 174.039 197.959 180.041 203.96C186.042 209.961 194.181 213.333 202.668 213.333H309.335C317.822 213.333 325.961 209.961 331.962 203.96C337.963 197.959 341.335 189.82 341.335 181.333V106.666H384.001V447.999H309.335V362.666C309.335 359.837 308.211 357.124 306.21 355.124C304.21 353.123 301.497 351.999 298.668 351.999H213.335C210.506 351.999 207.793 353.123 205.792 355.124C203.792 357.124 202.668 359.837 202.668 362.666V447.999H128.001V106.666ZM64.0013 213.333H106.668V447.999H64.0013V213.333Z"
        fill="#098689"
      />
      <path
        d="M224.001 138.665H245.335V159.999C245.335 162.828 246.458 165.541 248.459 167.541C250.459 169.542 253.172 170.665 256.001 170.665C258.83 170.665 261.543 169.542 263.544 167.541C265.544 165.541 266.668 162.828 266.668 159.999V138.665H288.001C290.83 138.665 293.543 137.542 295.544 135.541C297.544 133.541 298.668 130.828 298.668 127.999C298.668 125.17 297.544 122.457 295.544 120.456C293.543 118.456 290.83 117.332 288.001 117.332H266.668V95.9987C266.668 93.1697 265.544 90.4566 263.544 88.4562C261.543 86.4558 258.83 85.332 256.001 85.332C253.172 85.332 250.459 86.4558 248.459 88.4562C246.458 90.4566 245.335 93.1697 245.335 95.9987V117.332H224.001C221.172 117.332 218.459 118.456 216.459 120.456C214.458 122.457 213.335 125.17 213.335 127.999C213.335 130.828 214.458 133.541 216.459 135.541C218.459 137.542 221.172 138.665 224.001 138.665ZM181.335 266.665H202.668C205.497 266.665 208.21 265.542 210.21 263.541C212.211 261.541 213.335 258.828 213.335 255.999C213.335 253.17 212.211 250.457 210.21 248.456C208.21 246.456 205.497 245.332 202.668 245.332H181.335C178.506 245.332 175.793 246.456 173.792 248.456C171.792 250.457 170.668 253.17 170.668 255.999C170.668 258.828 171.792 261.541 173.792 263.541C175.793 265.542 178.506 266.665 181.335 266.665ZM213.335 309.332C213.335 306.503 212.211 303.79 210.21 301.79C208.21 299.789 205.497 298.665 202.668 298.665H181.335C178.506 298.665 175.793 299.789 173.792 301.79C171.792 303.79 170.668 306.503 170.668 309.332C170.668 312.161 171.792 314.874 173.792 316.875C175.793 318.875 178.506 319.999 181.335 319.999H202.668C205.497 319.999 208.21 318.875 210.21 316.875C212.211 314.874 213.335 312.161 213.335 309.332ZM245.335 266.665H266.668C269.497 266.665 272.21 265.542 274.21 263.541C276.211 261.541 277.335 258.828 277.335 255.999C277.335 253.17 276.211 250.457 274.21 248.456C272.21 246.456 269.497 245.332 266.668 245.332H245.335C242.506 245.332 239.793 246.456 237.792 248.456C235.792 250.457 234.668 253.17 234.668 255.999C234.668 258.828 235.792 261.541 237.792 263.541C239.793 265.542 242.506 266.665 245.335 266.665ZM245.335 319.999H266.668C269.497 319.999 272.21 318.875 274.21 316.875C276.211 314.874 277.335 312.161 277.335 309.332C277.335 306.503 276.211 303.79 274.21 301.79C272.21 299.789 269.497 298.665 266.668 298.665H245.335C242.506 298.665 239.793 299.789 237.792 301.79C235.792 303.79 234.668 306.503 234.668 309.332C234.668 312.161 235.792 314.874 237.792 316.875C239.793 318.875 242.506 319.999 245.335 319.999ZM309.335 266.665H330.668C333.497 266.665 336.21 265.542 338.21 263.541C340.211 261.541 341.335 258.828 341.335 255.999C341.335 253.17 340.211 250.457 338.21 248.456C336.21 246.456 333.497 245.332 330.668 245.332H309.335C306.506 245.332 303.793 246.456 301.792 248.456C299.792 250.457 298.668 253.17 298.668 255.999C298.668 258.828 299.792 261.541 301.792 263.541C303.793 265.542 306.506 266.665 309.335 266.665ZM309.335 319.999H330.668C333.497 319.999 336.21 318.875 338.21 316.875C340.211 314.874 341.335 312.161 341.335 309.332C341.335 306.503 340.211 303.79 338.21 301.79C336.21 299.789 333.497 298.665 330.668 298.665H309.335C306.506 298.665 303.793 299.789 301.792 301.79C299.792 303.79 298.668 306.503 298.668 309.332C298.668 312.161 299.792 314.874 301.792 316.875C303.793 318.875 306.506 319.999 309.335 319.999Z"
        fill="#098689"
      />
    </svg>
  );
};
